import React from "react";

const CheckboxInput = ({ label, val, checked, onChange, error }) => {
  return (
    <div className="form-group">
      <label className="checkbox-label">
        <input
          type="checkbox"
          checked={checked}
          onChange={(e) => onChange(val, e.target.checked)}
          value={val}
        />
        {label}
      </label>

      {error && <p className="error-text">{error}</p>}
    </div>
  );
};

export default CheckboxInput;
